import {Pipe, PipeTransform} from "@angular/core";
import {orderBy} from "lodash-es";
@Pipe({
    name: "orderBy",
    standalone: false
})
export class OrderByPipe implements PipeTransform {
    transform(array: any, sortBy: string, order?: "desc" | "asc"): any[] {
        const sortOrder = order ? order : "asc"; // setting default ascending order
        return OrderByPipe.orderByFunc(array, sortBy, sortOrder);
    }

    static orderByFunc = (array: any, sortBy: string, order?: "asc" | "desc"): any[] => {
        return orderBy(
            array,
            [data => (typeof data[sortBy] === "string" ? data[sortBy].toLowerCase() : data[sortBy])],
            [order]
        );
    };
}
